<template>
  <common-dialog ref="dialog" :title="title" width="1200px" :in-dialog="inDialog">
    <div class="index-tree-box">
      <div class="left-box">
        <div class="left-title">
          <span style="cursor: pointer;" @click="allData">所有分类</span>
        </div>
        <div class="left-main">
          <goods-tree ref="goodsTree" :is-edit="false" @on-select="onTreeSelect"></goods-tree>
        </div>
      </div>
      <div class="right-box">
        <list ref="list" :show-checkbox="multiple" :checkbox-fixed="false" :show-status="false">
          <template #column>
            <slot name="column" />
            <template v-if="selectable&&!multiple">
              <el-table-column label="操作" align="center" width="60" fixed="right">
                <template slot-scope="{row}">
                  <el-button @click="onSelect(row)" type="text">选择</el-button>
                </template>
              </el-table-column>
            </template>
          </template>
        </list>
      </div>
    </div>
    <template slot="footer">
      <slot name="footer">
        <el-button size="mini" type="primary" @click="selectMultiple" v-if="selectable&&multiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";
import goodsTree from "@/components/basicinfo/goods/archives/goodsTree/tree";

export default {
  components: { commonDialog, list, goodsTree },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "商品列表",
    },
  },
  data() {
    return {
      data: {
        IdChain: "",
        ClassName: "",
      },
      params: {},
    };
  },
  methods: {
    getTree() {
      this.$refs.goodsTree.getData();
    },
    getData(params) {
      this.params = { ...params };
      this.$refs.list.getData(this.params);
    },
    allData() {
      this.resetSelect();
      this.$refs.list.getData({ ...this.params, IdChain: "" });
      // 
    },
    resetSelect() {
      this.$refs.goodsTree.resetSelect();
      this.data.IdChain = "";
      this.data.ClassName = "";
    },
    onTreeSelect(data) {
      // 
      if (this.data.IdChain != data.IdChain) {
        this.data.IdChain = data.IdChain;
        this.data.ClassName = data.ClassName;
        this.$refs.list.getData({ ...this.params, IdChain: data.IdChain });
      }
    },
  },
};
</script>